import React, { useRef, useEffect, useState } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../../components/ui/tooltip';

type TruncateWithTooltipProps = {
  text: string;
  className?: string;
};

export const TruncateWithTooltip: React.FC<TruncateWithTooltipProps> = ({
  text,
  className = '',
}) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      const el = spanRef.current;
      if (el) {
        setIsTruncated(el.scrollWidth > el.clientWidth);
      }
    };
    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [text]);

  const span = (
    <span
      ref={spanRef}
      className={`truncate max-w-[90%] block cursor-pointer ${className}`}
      title={!isTruncated ? text : undefined}
    >
      {text}
    </span>
  );

  if (isTruncated) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>{span}</TooltipTrigger>
          <TooltipContent side="top">{text}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }
  return span;
};
